// IMPORTANT: must match with types defined @/server/src/modules/data-room/common/external-storage-integration/microsoft/types.ts
// TODO: SER-436 - Update usage of shared constants between client and server

import { DriveItem } from '@microsoft/microsoft-graph-types';

export type MicrosoftAccount = {
  email: string;
  accessToken: string;
};

/**
 * Microsoft File Interface
 * Combined interface for OneDrive and Sharepoint files
 */
export interface MicrosoftFile {
  id: string;
  siteId?: string | null; // Expects to be null for OneDrive files
  driveId: string;
  path: string;
  webUrl: string;
  name: string;
  mimeType: string;
  size: string;
  createdDateTime: string;
  lastModifiedDateTime: string;
}

// According to Microsoft's Graph API documentation,
// https://learn.microsoft.com/en-us/graph/api/resources/driveitem
export function mapMicrosoftGraphDriveItemToMicrosoftFile(driveItem: DriveItem): MicrosoftFile {
  return {
    id: driveItem.id ?? '',
    siteId: driveItem.parentReference?.siteId,
    driveId: driveItem.parentReference?.driveId ?? '',
    path: driveItem.parentReference?.path ?? '',
    webUrl: driveItem.webUrl ?? '',
    name: driveItem.name ?? driveItem.id ?? '',
    mimeType: driveItem.file?.mimeType ?? 'folder',
    size: driveItem.size?.toString() ?? '',
    createdDateTime: driveItem.createdDateTime ?? '',
    lastModifiedDateTime: driveItem.lastModifiedDateTime ?? '',
    // downloadUrl: driveItem['@microsoft.graph.downloadUrl'] ?? '', // Download URL is short-lived (1 hour) include if needed. Excluding for now
  };
}
